import { render, staticRenderFns } from "./ExpirationActionRows.vue?vue&type=template&id=01605bc4&"
import script from "./ExpirationActionRows.vue?vue&type=script&lang=js&"
export * from "./ExpirationActionRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports